import React from "react";
import Faqs from "../Components/home/Faqs";
import HomeSlider from "../Components/home/Slider";
import { Container } from "react-bootstrap";
import SectionTwo from "../Components/home/SectionTwo";
import ClinetsLogoSlider from "../Components/home/ClientsLogoSlider";
import GiftingIdeas from "../Components/home/GiftingIdeas";
import BlogTitle from "../Components/home/BlogTitle";
import DownloadCatalog from "../Components/home/DownloadCatalog";
import CustomerTestimonials from "../Components/home/CustomerTestimonials";
import DownloadReport from "../Components/home/DownloadReport";
import Instapost from "../Components/Instagram/InstaPost";

const Home =()=>{
    return(
        <>
        <div className="container-fluid p-0 bgeYantra">
        <HomeSlider/>
        <Container className="mt-5 mb-5 bgeYantra">
            <SectionTwo />
        </Container>
        <ClinetsLogoSlider/>
        <GiftingIdeas/>
        <BlogTitle/>
        <DownloadCatalog/>
        {/* <h2>Social Media Post Section</h2> */}
        <Instapost/>
        <CustomerTestimonials/>
        <DownloadReport/>
        </div>
        
        </>
    )
}

export default Home;